import Transition from "../components/transition";
import Helmet from "react-helmet";

import React from "react";
import PropTypes from "prop-types";

import styles from "./layout.module.scss";
try {
  require("smooth-scroll")('a[href*="#"]');
} catch (Any) {}

const Layout = ({ children, location }) => {
  /* Store UTM source in session storage */
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const utm_source = params.get("utm_source");
    if (utm_source) {
      sessionStorage.setItem("utm_source", utm_source);
    }
  }
  return (
    <>
      <div className={styles.wrapper}>
        <main>
          {" "}
          <Transition location={location}>{children}</Transition>
        </main>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
